(ns io.daskul.webapp.widgets.conversation.attachments
  "Pure view-model logic for message attachments in the conversation thread
   (SMS-248 — sticker/👍 render fidelity).

   Carries NO UI dependency (no `io.daskul.webapp.ui` / `@tabler` import) so it
   runs under the webapp-ui :node-test target — the JSX render lives in the
   tutorial conversation-thread view, mirroring the linked-leads split
   (frontend-component-architecture — separate logic from layout).")

(defn sticker?
  "True when an attachment is a Messenger sticker (the 👍 like included).

   Facebook delivers stickers as `image` attachments whose payload carries a
   `sticker_id`, which `parse-attachment` preserves under :provider-metadata
   (SMS-182) — so a sticker and a photo are both content-type \"image\" and this
   id is the only thing telling them apart. The distinction is purely
   presentational (a sticker renders small, a photo full-width), so it lives
   here at the render layer rather than as a backend content-type, which would
   need a data migration for existing rows (SMS-248)."
  [{:keys [type provider-metadata]}]
  (and (= "image" type)
       (some? (:sticker-id provider-metadata))))
